import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  affirmContent: {
    display: 'flex',
    justifyContent: 'space-between',

    '& .price': {
      textAlign: 'right',
      fontSize: Theme.typography.size[6],
      color: Theme.palette.blue1,
      fontFamily: Theme.typography.base.semiBold,

      [Theme.breakpoints.down('md')]: {
        fontSize: Theme.typography.size[4],
      },
      [Theme.breakpoints.down('xs')]: {
        fontSize: Theme.typography.size[3],
      },
    },

    '& .title': {
      fontSize: Theme.typography.size[2],
      lineHeight: '150%',
      marginTop: '0',
      color: Theme.palette.blue1,
      marginBottom: 5,
    },

    '& .date': {
      fontSize: Theme.typography.size[1],
      lineHeight: '150%',
      color: Theme.palette.grey1,
    },
    '& .affirmText': {
      fontSize: Theme.typography.size[1],
      fontFamily: Theme.typography.base.semiBold,
      color: Theme.palette.blue1,
      '& > img': {
        maxHeight: 20,
        maxWidth: 50,
      },
      [Theme.breakpoints.down('sm')]: {
        textAlign: 'right',
        fontSize: Theme.typography.pxToRem(12),
        '& > img': {
          maxWidth: 45,
        },
      },
    },

    '& .affirmLink': {
      fontFamily: Theme.typography.base.semiBold,
      fontStyle: 'normal',
      color: Theme.palette.blue1,
      textAlign: 'left',
      fontSize: Theme.typography.size[0],
      paddingTop: '4px',
      lineHeight: '14.4px',
      '& .affirm-as-low-as': {
        '& a': {
          textDecoration: 'none',
          color: Theme.palette.blue1,
          display: 'block',
          '& .affirm-ala-price': {
            color: Theme.palette.blue2,
          },
        },
      },
    },

    [Theme.breakpoints.down('xs')]: {
      alignItems: 'baseline',
      '& .price': {
        paddingTop: 16,
        fontSize: Theme.typography.size[3],
        lineHeight: '150%',
      },
    },
  },
  affirmAnnounceWidth: {
    width: 'auto',
  },
}));

export default useStyles;
